import React, { useEffect, useState } from "react";
import ReviewsComponentNew from "../components/ReviewsComponentNew/ReviewsComponentNew";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { CUSTOMER_REVIEWS } from "../api/constants";
import qs from "qs";

export default function CustomerReviews() {
  const { pathname } = useLocation();

  const [reviewsData, setReviewsData] = useState();

  useEffect(() => {
    const queryStr = qs.stringify({
      populate: "*",
    });
    const fetchCustomerReviews = async () => {
      try {
        const response = await axios.get(`${CUSTOMER_REVIEWS}?${queryStr}`);
        setReviewsData(response?.data?.data);
      } catch (error) {
        console.error("Error fetching home data:", error);
      }
    };

    fetchCustomerReviews();
  }, []);

  return (
    <>
      <Helmet>
        <link
          rel="alternate"
          hreflang="en-ae"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-us"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-gb"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-sg"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en-in"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="en"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
        <link
          rel="alternate"
          hreflang="x-default"
          href={`https://www.xrealty.ae/${pathname.replace("/", "")}`}
        />
      </Helmet>
      <div className="pt-28 pb-12 md:pt-36 lg:pt-48 xl:pt-48 flex flex-col gap-8 bg-black">
        <h1 className="font-[optima-lt-pro] uppercase text-2xl xs:text-3xl md:text-4xl text-center text-white">
          {reviewsData?.heading}
        </h1>
        <p className="text-white font-[optima-lt-pro] xl:mb-4 text-center xs:px-4 md:text-lg md:px-6 xl:text-xl">
          {reviewsData?.sub_heading}
        </p>
        <ReviewsComponentNew data={reviewsData} />
      </div>
    </>
  );
}
